<template>
    <div id="hero">
        <h1>Change starts at home.</h1>
        <p>Don't let the planet waste away.</p>
        <p>Download our app today.</p>
        <div id="buttons">
            <router-link class="button primary" to="/download">Download</router-link>
            <router-link class="button secondary" to="/features">Learn more</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "hero"
    };
</script>

<style scoped lang="scss">
    #hero {
        margin: 0.8em;
        margin-bottom: 0;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
        text-transform: uppercase;
    }

    #buttons {
        display: flex;
        justify-content: center;
    }

    .button {
        text-decoration: none;
        padding: 0.8em;
        
        border-radius: 3px;
        margin: 0em 0.2em 2em;
    }

    .primary {
        background: #42b983;
        color: white;
    }

    .secondary {
        color: #42b983;
        border: solid 1px;
    }
</style>
